import { sanitizeSensitiveParams } from "PFCore/helpers/url_sanitizer";
import { isFeatureEnabled } from "PFCore/helpers/use_is_feature_enabled";
import { CurrentAccount, FeatureFlag } from "PFTypes";

/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/no-unused-expressions */
export const setupChameleon = (currentAccount: CurrentAccount) => {
  const isEnabled = isFeatureEnabled(currentAccount);

  if (!window.PF.config.chameleon_token || !isEnabled(FeatureFlag.Chameleon)) {
    return;
  }

  // START Chameleon provided Snippet
  // @ts-expect-error vendor snippet, left as provided
  !(function (t, n, o) {
    var a = "chmln",
      e = "adminPreview",
      c = "setup identify alias track set show on off custom help _data".split(" ");
    if ((n[a] || (n[a] = {}), n[a][e] && (n[a][e] = !1), !n[a].root)) {
      (n[a].accountToken = o),
        (n[a].location = sanitizeSensitiveParams(n.location.href.toString())),
        (n[a].now = new Date());
      for (var s = 0; s < c.length; s++) {
        // @ts-expect-error vendor snippet, left as provided
        !(function () {
          var t = (n[a][`${c[s]}_a`] = []);
          n[a][c[s]] = function () {
            // @ts-expect-error vendor snippet, left as provided
            t.push(arguments);
          };
        })();
      }
      var i = t.createElement("script");
      (i.src = `https://fast.trychameleon.com/messo/${o}/messo.min.js`),
        (i.async = !0),
        t.head.appendChild(i);
    }
    // @ts-expect-error vendor snippet, left as provided
  })(document, window, PF.config.chameleon_token);
  // END Chameleon provided Snippet
};
